import type { FunctionComponent, HTMLAttributes } from "preact";
import { Dialog } from "../dialog/dialog.tsx";
import type { PhotoGridProps } from "../photo_grid/photo_grid.tsx";
import { PhotoGrid } from "../photo_grid/photo_grid.tsx";
import { useTranslator } from "../../hooks/i18n.ts";

export type PhotoSelectDialogProps = HTMLAttributes<HTMLDivElement> & PhotoGridProps & {
    isOpen: boolean;
    onCancel?: () => unknown;
    cameraId?: number;
};

export const PhotoSelectDialog: FunctionComponent<PhotoSelectDialogProps> = (props) => {
    const t = useTranslator();

    return <Dialog
        isOpen={props.isOpen}
        footer={false}
        showCloseButton
        title={t({zh: "选择照片", en: "Select Photo"})}
        onCancel={props.onCancel}
    >
        <div class="container" style="padding: 0; margin: 0 auto;">
            <PhotoGrid {...props}/>
        </div>
    </Dialog>;
};

export default PhotoSelectDialog;
